import { Button } from "@rio-cloud/rio-uikit";
import Dialog from "@rio-cloud/rio-uikit/Dialog";

interface Props{
    showDialog: boolean;
    enableSubmit: boolean;
    disableConfirm?: boolean;
    handleClose: () => void;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
    handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SaveName = ({showDialog, handleClose, handleSubmit, handleInputChange, enableSubmit,disableConfirm}: Props) => {
    return (
        <Dialog
            show={showDialog}
            onClose={handleClose}
            showCloseButton
            bsSize="md"
        >
            <form onSubmit={handleSubmit}>
                <Dialog.Title
                    title={""}
                    subtitle="Salvar Rota"
                    headerButtons={
                        <Button
                            bsStyle="muted"
                            iconOnly
                            iconName="rioglyph-cloud-download"
                        />
                    }
                />
                <Dialog.Body className="foo">
                    <div>
                        <div className="form-group">
                            <label htmlFor="demoInput">Nome da Rota</label>
                            <div className="webfont-preview display-flex align-items-center margin-top-10 margin-bottom-10">
                                <span className="rioglyph rioglyph-route-option text-size-20 margin-right-10"></span>

                                <input
                                    className="form-control"
                                    name="demoInput"
                                    maxLength={50}
                                    placeholder=""
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </Dialog.Body>
                <Dialog.Footer className="foobar">
                    <div className="display-flex gap-10 justify-content-end">
                        <Button
                            bsStyle="default"
                            type="button"
                            onClick={handleClose}
                            disabled={!enableSubmit}
                        >
                            Cancelar
                        </Button>
                        <Button
                            bsStyle="primary"
                            type="submit"
                            disabled={!enableSubmit || disableConfirm}
                        >
                            Salvar
                        </Button>
                    </div>
                </Dialog.Footer>
            </form>
        </Dialog>
    )
}

export default SaveName;